type LandelijkeFaciliteitenHeaderProps = {
    readOnly: boolean;
};

export function LandelijkeFaciliteitenHeader({ readOnly }: LandelijkeFaciliteitenHeaderProps) {
    const text = readOnly
        ? "De regievoerder kan landelijke faciliteiten aanvragen. Het gaat landelijk om alle vestigingen van:"
        : "Binnen landelijke faciliteiten kan je een verzoek doen om alle faciliteiten aan te zetten. Het gaat landelijk om alle vestigingen van:";

    return (
        <p>
            {text}
            <ul className="pl-4">
                <li className="list-item list-disc">Kiosk (koffie/thee)</li>
                <li className="list-item list-disc">StationsHuiskamer (koffie/thee)</li>
            </ul>
        </p>
    );
}
